import _ from 'lodash';
import { Component, Vue, Provide } from 'vue-property-decorator';
import sort from 'fast-sort';
import { SyncValue } from '@/services/Sync';

@Component
export default class SearchMixins extends Vue {

  @Provide()
  actualSearchText: string = ""

  @SyncValue("actualSearchText")
  search!: string;

  get searchIndexed() {
    return this.search.split('|')
      .map(e => e
        .split(' ')
        .filter(e => e)
        .map(e => e.toLowerCase())
      )
  }

  filterSearch<T>(array: T[], func: (f: T) => string): T[] {
    let searchIndexed = this.searchIndexed;
    return array
      .map(e => ({ item: e, text: func(e).toLowerCase() }))
      .filter(
        ({ item, text }) => searchIndexed
          .some(searchs => searchs
            .every(f => text.includes(f))
          ) 
        )
      .map(e => e.item)
  }
}

